interface IColorStatusLabel {
  Name: string
  Code?: string
  Icon?: string
  PrimaryColor?: string
  SecondaryColor?: string
  Description?: string
}

const getDynamicStatusColor = (dataSource: IColorStatusLabel[], statusName?: string) => {
  if (!statusName && !dataSource) return '#6b7280'
  const status = dataSource.find((s) => s.Name.toLowerCase() === statusName?.toLowerCase() || s.Code?.toLowerCase() === statusName?.toLowerCase())
  return status?.PrimaryColor || '#6b7280'
}

const getDynamicStatusBg = (dataSource: IColorStatusLabel[], statusName?: string) => {
  if (!statusName) return 'rgba(107, 114, 128, 0.1)'
  const status = dataSource.find((s) => s.Name.toLowerCase() === statusName.toLowerCase() || s.Code?.toLowerCase() === statusName?.toLowerCase())
  return status?.SecondaryColor || 'rgba(107, 114, 128, 0.1)'
}

const getDynamicStatusName = (dataSource: IColorStatusLabel[], statusCode?: string) => {
  if (!statusCode) return '-'
  const status = dataSource.find((s) => s.Code?.toLowerCase() === statusCode.toLowerCase())
  return status?.Name || '-'
}

const getDynamicStatusIcon = (dataSource: IColorStatusLabel[], statusCode?: string) => {
  if (!statusCode) return ''
  const status = dataSource.find((s) => s.Code?.toLowerCase() === statusCode.toLowerCase())
  return status?.Icon || ''
}

export {
  getDynamicStatusBg,
  getDynamicStatusColor,
  getDynamicStatusName,
  getDynamicStatusIcon
}